var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, PacemEventTarget } from './_default-imports';
//namespace Pacem.Components {
let PacemBeforeunloadElement = class PacemBeforeunloadElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._unloadingHandler = (evt) => {
            const msg = this.message;
            if (!this.active || this.disabled) {
                return;
            }
            if (evt.type === 'beforeunload') {
                evt.preventDefault();
                evt.returnValue = msg || '';
            }
            else if (!confirm(msg || 'Leave page?')) {
                evt.preventDefault();
            }
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        window.addEventListener('navigating', this._unloadingHandler, false);
        window.addEventListener('beforeunload', this._unloadingHandler, false);
    }
    disconnectedCallback() {
        window.removeEventListener('navigating', this._unloadingHandler, false);
        window.removeEventListener('beforeunload', this._unloadingHandler, false);
        super.disconnectedCallback();
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemBeforeunloadElement.prototype, "message", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemBeforeunloadElement.prototype, "active", void 0);
PacemBeforeunloadElement = __decorate([
    CustomElement({ tagName: P + '-beforeunload' })
], PacemBeforeunloadElement);
export { PacemBeforeunloadElement };
//}
